module.exports = "/packs/media/images/meeting4-4cce792ee478d5e22e4e6b8547a63d0d.jpg";